module.exports = __webpack_public_path__ + "media/icons/arrow-651c6fe6.svg";